module.exports = "./img/c397ea2453eb92a8ffc3c83143fea038.jpg";